import { HeaderIcon, Divider } from './atoms';
import {
  HeaderRoot,
  HeaderRow,
  HeaderStart,
  HeaderTitle,
  HeaderActions,
  HeaderBody,
  InteractiveButton,
} from './components';

export const SurfaceHeader = {
  Root: HeaderRoot,
  Row: HeaderRow,
  Start: HeaderStart,
  Title: HeaderTitle,
  InteractiveButton,
  Actions: HeaderActions,
  Icon: HeaderIcon,
  Body: HeaderBody,
  Divider,
};
